// Phí, Lệ phí
export default {
  Fee: 0, // phí
  Fees: 1, // lệ phí
};
